import { useState, useEffect } from 'react';

export default function useSignatureStore() {
    const [savedSignatures, setSavedSignatures] = useState([]);

    // Load saved signatures from localStorage on mount
    useEffect(() => {
        const storedSignatures = localStorage.getItem('savedSignatures');
        if (storedSignatures) {
            try {
                setSavedSignatures(JSON.parse(storedSignatures));
            } catch (error) {
                console.error("Failed to parse saved signatures:", error);
                localStorage.setItem('savedSignatures', JSON.stringify([]));
            }
        }
    }, []);

    // Update localStorage when signatures change
    useEffect(() => {
        try {
            localStorage.setItem('savedSignatures', JSON.stringify(savedSignatures));
        } catch (error) {
            console.error("Failed to save signatures to localStorage:", error);
        }
    }, [savedSignatures]);

    // Save a new signature and ensure it's immediately stored
    const saveSignature = (newSignature) => {
        const updatedSignatures = [...savedSignatures, newSignature];
        setSavedSignatures(updatedSignatures);
        // For extra safety, also directly update localStorage
        try {
            localStorage.setItem('savedSignatures', JSON.stringify(updatedSignatures));
        } catch (error) {
            console.error("Failed to immediately save signature:", error);
        }
    };

    // Delete a signature
    const deleteSavedSignature = (id, e) => {
        if (e) e.stopPropagation();
        const updatedSignatures = savedSignatures.filter(sig => sig.id !== id);
        setSavedSignatures(updatedSignatures);
        // For extra safety, also directly update localStorage
        try {
            localStorage.setItem('savedSignatures', JSON.stringify(updatedSignatures));
        } catch (error) {
            console.error("Failed to immediately remove signature:", error);
        }
    };

    return {
        savedSignatures,
        setSavedSignatures,
        saveSignature,
        deleteSavedSignature
    };
}